export default __webpack_public_path__ + "static/media/dostup.69626332.svg";